module.exports = __webpack_public_path__ + "static/img/IMG_20170313_114912.edfb4d94.jpg";